
export enum AllFilter {
	All = 'All'
}


export enum ResearchRole {
	Administrator = 'Administrator',
	Editor = 'Editor',
	Contributor = 'Contributor',
	Subscriber = 'Subscriber'
}

export const RoleScopes = {
	[ResearchRole.Administrator]: 'admin:insights',
	[ResearchRole.Editor]: 'insights:content-publish',
	[ResearchRole.Contributor]: 'insights:content-edit',
	[ResearchRole.Subscriber]: 'insights:content-reader'
};

export enum ArticleSelectionKind {
	Today = 'today',
	All = 'all',
	MyArticles = 'my',
	Published = 'published',
	Pending = 'pending',
	Archived = 'archived'
}

export const articleSelectionLabel = {
	[ArticleSelectionKind.Today]: 'Today',
	[ArticleSelectionKind.All]: 'All',
	[ArticleSelectionKind.MyArticles]: 'My articles',
	[ArticleSelectionKind.Published]: 'Published',
	[ArticleSelectionKind.Pending]: 'Pending',
	[ArticleSelectionKind.Archived]: 'Archived'
};

export enum ArticleChangeHookType {
	DetailsPublished,
	DetailsContributor,
	DetailsSummary,
	DetailsPublishDate,
	DetailsOpenToAll,
	DetailsChannel,
	DetailsPremiumOffset,
	DetailsShowWatermark,
	DetailsDisplayInChartSection,
	DetailsIsPinned,
	DetailsIsTimeless,
	TaxonomySection,
	TaxonomyCategories,
	TaxonomyTags
}

export enum ArticleState {
	Pending = 'Pending',
	ReadyForReview = 'ReadyForReview',
	Published = 'Published',
	Archived = 'Archived'
}

export enum ArticleEditError {
	TextAbsent = 'TextAbsent',
	PublisherAbsent = 'PublisherAbsent',
	ContributorAbsent  = 'ContributorAbsent',
	SummaryAbsent = 'SummaryAbsent',
	CategoriesAbsent = 'CategoriesAbsent',
	TitleAbsent = 'TitleAbsent',
	ChannelAbsent = 'ChannelAbsent',
}

export enum PremiumChannelKind {
	'All' = 'All',
	'My Channels' = 'My Channels',
	'Archived' = 'Archived'
}

export enum PremiumChannelType {
	'All' = 'All types',
	'Premium' = 'Premium',
	'Free' = 'Free'
}

export const premiumChannelLabel = {
	[PremiumChannelKind['All']]: 'All channels',
	[PremiumChannelKind['My Channels']]: 'My Channels',
	[PremiumChannelKind['Archived']]: 'Archived'
};

export enum ChannelSubscriberKind {
	All = 'All',
	Active = 'Active',
	Paid = 'Paid',
	NonCharge = 'NonCharge',
	Unsubscribed = 'Unsubscribed',
	Expired = 'Expired',
	PaymentFailed = 'PaymentFailed',
	Trial = 'Trial'
}

export const premiumChannelSubscriberLabel = {
	[ChannelSubscriberKind.All]: 'All subscribers',
	[ChannelSubscriberKind.Paid]: 'Paid',
	[ChannelSubscriberKind.NonCharge]: 'Non-charge',
	[ChannelSubscriberKind.Unsubscribed]: 'Unsubscribed',
	[ChannelSubscriberKind.Expired]: 'Expired',
	[ChannelSubscriberKind.PaymentFailed]: 'Payment Failed',
	[ChannelSubscriberKind.Trial]: 'Trial users'
};

export const freeOpenChannelSubscriberLabel = {
	[ChannelSubscriberKind.All]: 'All subscribers',
	[ChannelSubscriberKind.Unsubscribed]: 'Unsubscribed'
}

export const freeClosedChannelSubscriberLabel = {
	[ChannelSubscriberKind.All]: 'All subscribers',
	[ChannelSubscriberKind.Active]: 'Active',
	[ChannelSubscriberKind.Unsubscribed]: 'Unsubscribed'
}
